















































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import { NSLog } from "@/helpers/log";
import {
  edit as EditPackage,
  disable as DisablePackage
} from "@/dialogs/package";
import { Package } from "@/models/package";
import { PackageGroup } from "@/models/packagegroup";
import ProductIcon from "@/components/ProductIcon.vue";
const log = NSLog("view/ManagePackages");

@Component({
  components: {
    loader,
    EditPackage,
    DisablePackage,
    ProductIcon
  }
})
export default class ManagePackages extends Vue {
  private get visiblePackages() {
    if (this.onlyVisible) {
      return this.packages.filter(
        (p: Package) => p.is_visible_state !== "Expired"
      );
    }
    return this.packages;
  }

  private get packagesGroupedByPackageGroup() {
    const pgs: any = {};
    this.visiblePackages.map((p: Package | any) => {
      p._ssCode =
        p._ssCode ||
        p.code.substr(0, 3) +
          (p.sku < 1000 ? ("00000" + p.sku).substr(-3) : p.sku);
      p._changed = p._changed || false;
      p._newPrice = p._newPrice || false;
      pgs[p.package_group_id] = pgs[p.package_group_id] || [];
      pgs[p.package_group_id].push(p);
    });

    return this.packageGroups
      .sort((a: PackageGroup, b: PackageGroup) => (a.title > b.title ? 1 : -1))
      .map((pg: PackageGroup) => ({
        _changed: false,
        id: pg.id,
        title: pg.title,
        packages: pgs[pg.group] || []
      }));
  }

  private get packagesGroupedByPackageGroupAndSSCode() {
    const groups: any = [];

    // loop package groups
    for (const groupID of Object.keys(this.packagesGroupedByPackageGroup)) {
      const group = this.packagesGroupedByPackageGroup[groupID];
      if (!group.packages.length) {
        groups.push(group);
        continue;
      }

      // create sscode grouping
      const groupSSCodes: any = {};
      group.packages.map((pkg: any) => {
        groupSSCodes[pkg._ssCode] = groupSSCodes[pkg._ssCode] || [];
        groupSSCodes[pkg._ssCode].push(pkg);
      });

      // reset group packages
      group.packages = [];

      // loop over sscodes to create packages
      for (const ssCode of Object.keys(groupSSCodes)) {
        const pkgs = groupSSCodes[ssCode];
        group.packages.push({
          _ssCode: ssCode,
          code: ssCode,
          packages: pkgs,
          title: this.uniqueProps(pkgs, "title").join("<br/>"),
          _OZARPkg: pkgs.find(
            (p: Package) => p.interval === "once" && p.currency === "ZAR"
          ),
          _OUSDPkg: pkgs.find(
            (p: Package) => p.interval === "once" && p.currency === "USD"
          ),
          _MZARPkg: pkgs.find(
            (p: Package) => p.interval === "month" && p.currency === "ZAR"
          ),
          _YZARPkg: pkgs.find(
            (p: Package) => p.interval === "year" && p.currency === "ZAR"
          ),
          _MUSDPkg: pkgs.find(
            (p: Package) => p.interval === "month" && p.currency === "USD"
          ),
          _YUSDPkg: pkgs.find(
            (p: Package) => p.interval === "year" && p.currency === "USD"
          )
        });
      }
      groups.push(group);
    }
    return groups;
  }

  public get categories() {
    return this.packages.map((p: Package) => p.category);
  }
  public packages: Package[] = [];

  @Getter("packageGroups") public packageGroups: any;
  @Mutation("setLastErr") public setLastErr: any;

  public headers = [
    { text: "SSCode", value: "_ssCode" },
    // { text: "Code", value: "code" },
    {
      text: "Title",
      align: "left",
      sortable: true,
      value: "title"
    },

    { text: "Once-off / ZAR", value: "_ssCode", sortable: false },
    { text: "Once-off / USD", value: "_ssCode", sortable: false },

    { text: "Monthly / ZAR", value: "_ssCode", sortable: false },
    { text: "Annual / ZAR", value: "_ssCode", sortable: false },

    { text: "Monthly / USD", value: "_ssCode", sortable: false },
    { text: "Annual / USD", value: "_ssCode", sortable: false },

    // { text: "Interval", value: "interval" },
    // { text: "Price", value: "price" },
    // { text: "Currency", value: "currency" },
    // // { text: "Expiry", value: "expiry" },
    // { text: "Updated", value: "updated_at" },
    { text: "", value: "" }
  ];

  public headersExpand = [
    { text: "Code", value: "code" },
    {
      text: "Title",
      align: "left",
      sortable: true,
      value: "title"
    },

    { text: "Interval", value: "interval" },
    { text: "Price", value: "price" },
    { text: "Currency", value: "currency" },
    { text: "Updated", value: "updated_at" },

    { text: "Cart Description", value: "description" },
    { text: "Invoice Description", value: "long_description" },

    { text: "", value: "" }
  ];

  private loading = false;
  private saving = false;
  private onlyVisible = true;

  private pagination: any = {
    // descending: boolean",
    // page: number",
    rowsPerPage: -1,
    sortBy: "_ssCode"
    // totalItems: number"
  };

  private editPackage: Package | boolean = false;
  private disablePackage: Package | boolean = false;
  public getGroupPackages(groupID: number) {
    return this.visiblePackages.filter(
      (p: Package) => p.package_group_id === groupID
    );
  }

  public packageUpdated(pkg: Package | boolean | any, oldPkg?: Package) {
    this.editPackage = false;
    this.disablePackage = false;
    if (!pkg) {
      return;
    }

    // if just a bool from dialog, return
    if (pkg === true || !oldPkg) {
      return;
    }

    pkg._changed = true;
    pkg._oldCode = oldPkg.code;
    const newPkgs = this.packages.filter((p: Package) => p.id !== oldPkg.id);
    newPkgs.push(pkg);
    this.packages = newPkgs;
  }

  public created() {
    this.refreshPackages();
  }

  @debounce(250, { leading: false })
  public updatePrice(pkg: Package | any, price: number) {
    // this.packages.splice(this.packages.find((fp:Package)=>pkg.id === ))
    pkg._changed = true;
    pkg._newPrice = price;
    if (+pkg._newPrice === +pkg.price) {
      pkg._newPrice = false;
      pkg._changed = false;
    }
    // this.packages = this.packages
    this.packages.splice(0, 0);

    this.packagesGroupedByPackageGroup.map((pg: any) => {
      pg._changed = pg.packages.find((p: any) => (p._changed ? true : false));
    });
  }

  public beforeDestroy() {
    cancel(this.updatePrice);
  }

  public async savePriceChanges() {
    this.saving = true;
    let p: any;
    for (p of this.packages.filter((pFilter: any) => pFilter._newPrice)) {
      try {
        p._saving = true;
        let savePkg = { ...p, price: p._newPrice };
        savePkg = await billingApi.updatePackage(savePkg);
        this.packageUpdated(savePkg, p);
      } catch (err) {
        this.setLastErr(String(err));
      }
    }
    this.saving = false;
  }

  private uniqueProps(items: any[], prop: string) {
    const unique: any[] = [];
    items.map((it: any) => {
      if (!unique.find((existing: any) => existing === it[prop])) {
        unique.push(it[prop]);
      }
    });
    return unique;
  }

  private async refreshPackages() {
    this.loading = true;
    try {
      this.packages = await billingApi.listPackages();
    } catch (err) {
      log("err", err);
    }
    this.loading = false;
  }

  private expandItem(item: any, expand: any) {
    item.expanded = !item.expanded;
  }
}
